import { TimeseriesValues } from '../../local_modules/voy-timeseries-chart/src/echartUtils';
import { LegData, LegInfo, CurrentLeg, ParameterValue } from '../models/vessel-performance-model';

export class PerformanceUtils {
    static ZeroLegData() : LegData {
        return {
            title: "",
            unit: "",
            current: 0.0,
            nextLeg: 0.0,
            simulated: { value: 0.0 },
            max: 0.0
        }
    }
    
    static ZeroLegInfo() : LegInfo {
        return {
            nextLegWaypointDetails: "",
            eta: null,
            distance: 0.0,
            distanceToPilot: 0.0,
            timeToPilot: 0,
            etaAtPilot: null,
            avgSpeedToPilot: 0.0
        }
    }
    
    static ZeroCurrentLeg() : CurrentLeg {
        return {
            MEPower: { title: "ME POWER", unit: "KW", current: null, nextLeg: null, simulated: null },
            RPM: { title: "ME RPM", unit: "RPM", current: null, nextLeg: null, simulated: null },
            SOG: { title: "SOG", unit: "Kt", current: null, nextLeg: null, simulated: null },
            STW: { title: "STW", unit: "Kt", current: null, nextLeg: null, simulated: null },
            info: PerformanceUtils.ZeroLegInfo()
        };
    }

    static paramValuesToTimeseries(values: ParameterValue[]): TimeseriesValues
    {
        const result: TimeseriesValues = {
            timestamps: [],
            values: [],
        };

        if (values[0].lower !== undefined && values[0].upper !== undefined)
        {
            result.lower = [];
            result.upper = [];
        }

        for (const value of values)
        {
            result.timestamps.push(value.timestamp);
            result.values.push(value.value);
            if (result.lower && result.upper)
            {
                result.lower.push(value.lower!);
                result.upper.push(value.upper!);
            }
        }

        return result;
    }
}